/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable productions
import { tableSchemaBase as columns } from '../productions.columns';
import { tableSchemaBase as columnsWithoutContact } from '../productionsWithContact.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IProductionsDatatableSlice {
	productionsDatatableOptions: TColumnsSchema[];
	setProductionsDatatableOptions: (
		_productionsDatatableOptions: TColumnsSchema[]
	) => void;
	productionsWithoutContactDatatableOptions: TColumnsSchema[];
	setProductionsWithoutContactDatatableOptions: (
		_productionsDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeProductionsDatatableSlice = (
	s: any
): any => ({
	productionsDatatableOptions:
		s.productionsDatatableOptions,
	productionsWithoutContactDatatableOptions:
		s.productionsWithoutContactDatatableOptions,
});

const initialState = {
	productionsDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
	productionsWithoutContactDatatableOptions:
		columnsWithoutContact.filter(
			(item) => item.defaultVisible
		),
};

export const createProductionsDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', any]],
	[],
	IProductionsDatatableSlice
> = (set) => ({
	...initialState,
	setProductionsDatatableOptions: (
		_productionsDatatableOptions: TColumnsSchema[]
	) =>
		set({
			productionsDatatableOptions:
				_productionsDatatableOptions,
		}),
	setProductionsWithoutContactDatatableOptions: (
		_productionsDatatableOptions: TColumnsSchema[]
	) =>
		set({
			productionsWithoutContactDatatableOptions:
				_productionsDatatableOptions,
		}),
});
